// extracted by mini-css-extract-plugin
export default {"PhotoColumn":"PhotoColumn_PhotoColumn__eOruf"};